import React from 'react'

const SvgMegaphoneOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.712 4.527c.979-.652 2.29.05 2.29 1.226V16.26c0 1.135-1.226 1.826-2.188 1.277l-.092-.057-2.055-1.37a6.568 6.568 0 00-3.666-1.102v3.49A1.5 1.5 0 016.501 20l-.153-.008A1.502 1.502 0 015 18.5v-3.5h-.997l-.205-.009A2.001 2.001 0 012.002 13V9c0-1.035.787-1.887 1.796-1.99L4.002 7h3l.366-.006a9.912 9.912 0 004.822-1.46l.309-.198 1.213-.809zm-.105 2.474a11.91 11.91 0 01-5.605 1.955v4.052a8.568 8.568 0 014.774 1.438l1.226.817V6.737l-.395.264zM4.002 13l2-.001V9h-2V13z'
    />
    <path d='M17.797 14.793a1 1 0 011.414 0l1.5 1.5a1 1 0 01-1.414 1.414l-1.5-1.5a1 1 0 010-1.414zM21.004 10a1 1 0 110 2h-2a1 1 0 010-2h2zM19.297 4.293a1 1 0 111.414 1.414l-1.5 1.5a1 1 0 01-1.414-1.414l1.5-1.5z' />
  </svg>
)

export default SvgMegaphoneOutline
